var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5827 21.2505L5.41647 21.2505L5.41647 18.7505L34.5827 18.7505L34.5827 21.2505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3332 18.7505C27.4538 18.7505 22.6497 23.9207 22.6497 29.4339L22.6497 30.6839L25.1497 30.6839L25.1497 29.4339C25.1497 25.2479 28.8875 21.2505 33.3332 21.2505L34.5827 21.2505L34.5827 18.7505L33.3332 18.7505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3332 21.2505C27.4538 21.2505 22.6497 16.0803 22.6497 10.567L22.6497 9.317L25.1497 9.317L25.1497 10.567C25.1497 14.753 28.8875 18.7505 33.3332 18.7505L34.5827 18.7505L34.5827 21.2505L33.3332 21.2505Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow2);
export default __webpack_public_path__ + "static/media/right-arrow-2.464f3e73b9cf77be30516fc3dcfe15c5.svg";
export { ForwardRef as ReactComponent };